import client from './utils/http'

export interface CamItem {
    'id': string | number,
    'title': string,
    'description': string,
    'stream': string,
    'img': string,
    'tags': string,
    'cat': string | number,
    'display': boolean | string
}

interface Categories {
    id: string | number,
    title: string,
    description?: string,
    img: string
}

interface ContentEntries {
    title?: string, content?:string, description?: string
}

interface Content{
    'agreement': Array<ContentEntries>,
    'cookieAgreement': Array<ContentEntries>,
    'gallery': Array<ContentEntries>,
    'aboutUs': Array<ContentEntries>,
    'wowzaKey': Array<ContentEntries>,
    'add': Array<{
        id: string,
        img: string,
        link: string,
        title: string
    }>
}

export interface CamResponse {
    tags: Array<{
        id: string | number,
        title: string
    }>
    cats: Categories[],
    items: CamItem[],
    content: Content
}


export const getCamData = async (): Promise<CamResponse> =>
{
	const url = '//tarnow.net.pl/widget/getstreamservice'
	const {data} = await client.get(url)
	return data
}